export const ROLES = Object.freeze({
  SUPER_ADMIN: 'SUPER_ADMIN',
  ADMIN: 'ADMIN',
  STAFF: 'STAFF',
  VENDOR: 'VENDOR',
  USER: 'USER'
});

export const ROLE_LABEL = {
  SUPER_ADMIN: 'Super Admin',
  ADMIN: 'Admin',
  STAFF: 'Staff',
  VENDOR: 'Clinic',
  USER: 'User'
};

export function isAdminish(role) {
  return role === ROLES.SUPER_ADMIN || role === ROLES.ADMIN || role === ROLES.STAFF;
}

export function isSuper(role) {
  return role === ROLES.SUPER_ADMIN;
}

export function defaultLandingFor(role) {
  switch (role) {
    case ROLES.SUPER_ADMIN: return '/dashboard';
    case ROLES.ADMIN:
    case ROLES.STAFF:       return '/dashboard';
    case ROLES.VENDOR:      return '/dashboard';
    case ROLES.USER:
    default:                return '/dashboard';
  }
}
